<template>
  <div class="StaffManage">
    <StaffManageList @tipOpen="dialogVisible = true" />
    <StaffManageChart />
    <StaffManageTable />

    <el-dialog
      title="数据名称信息拉齐"
      :visible.sync="dialogVisible"
      width="450px"
    >
      <GlobalTable
        :columns="tableColumns"
        :data="tableData"
        :isPagination="false"
        :isIndex="false"
      >
      </GlobalTable>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    StaffManageList: () => import("./list"),
    StaffManageChart: () => import("./dataBoard"),
    StaffManageTable: () => import("./table"),
  },
  data() {
    return {
      isManager: false,
      formItemList: [
        {
          key: "staffName",
          type: "input",
          labelName: "职员名称",
          placeholder: "请输入职员名称",
        },
        {
          key: "staffMobile",
          type: "input",
          labelName: "联系电话",
          placeholder: "请输入联系电话",
        },
        { slotName: "operationSelect" },
        { slot: "AddSlot" },
      ],

      // 对齐弹框部分
      dialogVisible: false,
      tableColumns: [
        { label: "页面字段", prop: "key" },
        { label: "系统字段", prop: "word" },
      ],
      tableData: [
        {
          key: "回收量",
          word: "成交量",
        },
        {
          key: "回收金额",
          word: "用户成交价",
        },
        {
          key: "返佣",
          word: "公司返利利润",
        },
        {
          key: "项目部",
          word: "平台后台的门店商家",
        },
        {
          key: "门店",
          word: "门店系统的区域",
        },
        {
          key: "柜组",
          word: "门店系统的门店",
        },
        {
          key: "柜组标签",
          word: "门店系统门店标签",
        },
        {
          key: "事业部返佣",
          word: "门店系统预留返利",
        },
        {
          key: "预留返佣",
          word: "门店系统的门店返利",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    BtnClick(isManager) {
      this.isManager = isManager;
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.StaffManage {
  /deep/ .tipsIcon {
    width: 9px;
    height: 9px;
    vertical-align: middle;
    margin-left: 5px;
  }
  /deep/ .titleIcon {
    width: 30px;
    height: 30px;
    vertical-align: middle;
    margin-right: 10px;
  }

  /deep/ .el-date-editor--daterange {
    width: 272px !important;
  }

  /deep/ .el-form-group_isRound {
    .el-input__inner {
      border-radius: unset !important;
    }
  }

  /deep/ .el-tooltip__popper.is-dark {
    opacity: 0.5;
  }
}
</style>
